// removed by extract-text-webpack-plugin
module.exports = {"Modal":"Modal__Modal__bDd91","openUp":"Modal__openUp__1laZN","MarginTop":"Modal__MarginTop__BhKnH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/modal/Modal.css
// module id = 126
// module chunks = 3